import React, { useEffect, useState } from "react";
import useCoreAgoraCheck from "../../../../general/customHooks/coreAgoraCheck";
import { ExclamationTriangle } from "react-bootstrap-icons";
import {
  LogoFullColor,
  LogoFullWhite,
} from "../../../../general/assets/assets";

export default function SessionEndView() {
  return (
    <div className="flex items-center justify-center h-screen bg-black">
      <div className="w-full aspect-video max-w-5xl  relative flex flex-col items-center justify-center gap-2  rounded-md">
        <div className="">
          <LogoFullColor className="h-20" />
        </div>

        <label className="font-medium text-lg text-white">SESSION END</label>
        <label className=" text-base text-white">You can close this page</label>
      </div>
    </div>
  );
}
